import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api';
import { BaseResponse, PublicTenant } from 'types';

import { apiQuery } from '../../query';

export const tenantsApi = createApi({
  baseQuery: apiQuery,
  reducerPath: 'tenantsApi',
  endpoints: (build) => ({
    publicList: build.query<PublicTenant[], void>({
      query: () => ({
        method: 'get',
        url: URL.PUBLIC_TENANTS,
      }),
      transformResponse: (response: BaseResponse<PublicTenant[]>) =>
        response.data,
    }),
  }),
});

export const { usePublicListQuery: usePublicTenantsQuery } = tenantsApi;
